module.exports = __webpack_public_path__ + "img/18.6bbcf5c0.jpg";